import { Link } from 'react-router-dom';
import { ROUTES } from '../routes';
import { Home } from 'lucide-react';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-full gap-6 text-center p-8">
      <div className="text-6xl font-bold text-zinc-700">404</div>
      <h1 className="text-xl font-semibold text-zinc-200">Page non trouvée</h1>
      <p className="text-sm text-zinc-500 max-w-sm">
        La page que vous cherchez n'existe pas ou a été déplacée.
      </p>
      <Link
        to={ROUTES.dashboard}
        className="flex items-center gap-2 px-5 py-2.5 bg-zinc-800 hover:bg-zinc-700 text-zinc-200 border border-zinc-700 rounded-xl text-sm font-medium transition-colors"
      >
        <Home className="w-4 h-4" />
        Retour au dashboard
      </Link>
    </div>
  );
}
